/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

export class SubscriptionVisibilityDto{
  legalEntityDTO: LegalEntityModel | null = null;

  subscriptionTypeId: string | null = null;
}
